import React from 'react';
import { Formik, Field } from "formik";


const ColorSelect = (props) => <Field name={props.name}>
  {({ field, form }) => (
      <div className="field-group--inline">
        <label className="label-inline">{ props.label }</label>
        <input value={ field.value } onChange={(e) => { form.setFieldValue(props.name, e.target.value); } } className="tiny" type='color' />
      </div>)}
</Field>;

export default ColorSelect;



// WEBPACK FOOTER //
// ./src/components/ColorSelect/ColorSelect.js